import { UICoinsController } from '../../../shared/scripts/ui_coins/UICoinsController.ts';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UIMCoinsController extends UICoinsController {
    initCoinClick() {
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return;
        setElementOnClick(this.headerCoinsContainer, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendCoinClickAnalytic();
            this.sceneController.loadScene(UIMSceneEnum.Store);
        });
        this.headerCoinsContainer.style.transition = '';
    }
    setCoins(coinAmount) {
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return;
        super.setCoins(coinAmount);
        this.headerCoinsContainer.style.maxWidth = this.headerCoinsContainer.clientWidth + 'px';
    }
    constructor(sceneController){
        super();
        this.sceneController = sceneController;
    }
}
